import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Observable, Subject} from "rxjs";
import {Centre, CentreOption} from "../../../../../interfaces/Centres";
import {ActivatedRoute, Router} from "@angular/router";
import {CentreService} from "../../../../../services/centre.service";
import {LogService} from "../../../../../services/log.service";
import {EmployeeService} from "../../../../../services/employee.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {CounsellingWorkUpdateService} from "../counselling-work-update.service";
import {Employee} from "../../../../../interfaces/Employee";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {map, takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-add-edit-work-update',
  templateUrl: './add-edit-work-update.component.html',
  styleUrls: ['./add-edit-work-update.component.scss']
})
export class AddEditWorkUpdateComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  counsellingWorkForm!: FormGroup;
  id: string | null = null;
  centres$!: Observable<CentreOption[]>;
  displayCentre = (c: any) => c?.centreName;
  displayTeacher = (c: any) => c?.userName;
  filteredTeachers$!: Observable<any[]>;
  teachers$: Observable<any[]>
  isLoading: boolean = false;
  selectedCentre: any;
  counselorName: any
  employeeData!: Employee[];
  selectedCounselorName: string[] = [];
  selectTeachers: any;
  userData = JSON.parse(localStorage.getItem('userData')!).userName
  maxDate: Date;

  constructor(
    private fb: FormBuilder,
    private service: CounsellingWorkUpdateService,
    private route: ActivatedRoute,
    private router: Router,
    private mCentreService: CentreService,
    private mLogService: LogService,
    private mEmployeeService: EmployeeService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  protected mDialogRef:MatDialogRef<AddEditWorkUpdateComponent>,
  ) {
    this.maxDate = new Date();
    this.centres$ = this.mCentreService.getAllCentres().pipe(
      map((centres: Centre[]) => [{centreName:'HO',centreCode:'HO'},...centres] )
    )

    this.teachers$ = this.mEmployeeService.getTeachers();
    this.teachers$.pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
      console.log(res)
    })
  }

  ngOnInit(): void {
    this.id = this.data?.id || null;
    this.fetchCounsellor()
    this.counsellingWorkForm = this.fb.group({
      date: [new Date(), Validators.required],
      counsellorName: ['', Validators.required],
      centre: [[]],
      submittedBy: [''],
      task: ['', Validators.required],
      remarks: ['']
    });
    // default load teachers
    this.filteredTeachers$ = this.teachers$;
    if(this.userData){
      this.counsellingWorkForm.patchValue({counsellorName: this.userData,})
    }
    if (this.id) {
      this.service.getWorkUpdateById(this.id).pipe(takeUntil(this._destroyed$)).subscribe((data: any) => {
        this.teachers$.pipe(takeUntil(this._destroyed$)).subscribe((allTeachers: any[]) => {
          const selectedTeacher = allTeachers.find((t: any) => t.userId === data?.submittedBy?.userId);
          this.counsellingWorkForm.patchValue({
            date: data?.date?.toDate(),
            counsellorName: data?.counsellorName,
            centre: data?.centre || [],
            submittedBy: selectedTeacher || data?.submittedBy,
            task: data?.task,
            remarks: data?.remarks
          });

          // Update selectedCentre to handle multiple selections
          this.selectedCentre = data?.centre || [];
        });
      });
    }

  }

  submit() {
    if (this.counsellingWorkForm.invalid) return;

    this.isLoading = true;

    // Get logged-in userData from localStorage
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    this.counsellingWorkForm.patchValue({
      submittedBy: userData.userName || ''
    });

    const formValue = this.counsellingWorkForm.value;

    const request = this.id
      ? this.service.updateWorkUpdate(this.id, formValue)
      : this.service.addWorkUpdate(formValue);

    request
      .then(() => {
        const activity = {
          date: new Date().getTime(),
          section: 'Work Updates',
          action: this.id ? 'Update' : 'Submit',
          description: `Work Update ${this.id ? 'updated' : 'added'} by ${userData.userName}`,
          currentIp: localStorage.getItem('currentip')!
        };
        this.mLogService.addLog(activity);

        this.isLoading = false;

        this.snackBar.open(
          `Work Update ${this.id ? 'updated' : 'added'} successfully!`,
          'Close',
          {
            duration: 3000,
            verticalPosition: 'top',
            panelClass: ['snackbar-success']
          }
        );

        this.mDialogRef.close(true);
      })
      .catch(() => {
        this.isLoading = false;

        this.snackBar.open('Failed to save Work Update.', 'Close', {
          duration: 3000,
          verticalPosition: 'top',
          panelClass: ['snackbar-error']
        });
      });
  }


  fetchCounsellor() {
    this.mEmployeeService.getUsers().pipe(takeUntil(this._destroyed$)).subscribe(snapshotchanges => {
      this.employeeData = snapshotchanges.map(w => {
        let emp = w.payload.toJSON() as Employee;
        if (w.key != null) {
          emp['id'] = w.key;
        }
        return emp;
      });

      const namesToRemove = ['Shilpa Pahuja', 'Mukti Panchamia'];

      this.counselorName = this.employeeData
        .filter(employee => (employee?.role === 'Counsellor' || employee?.role === 'Lead Counsellor' || employee?.role === 'Sr Counsellor') && employee.disabled !== true)
        .map(counsellingEmployee => ({name: counsellingEmployee?.userName})) // wrap as object
        .filter(c => !namesToRemove.includes(c?.name))
        .sort((a, b) => a?.name.localeCompare(b?.name));
    });

  }

  // onCentreSelect($event: any) {
  //   console.log($event)
  //   this.counsellingWorkForm.patchValue({
  //     centreName: $event.centreName,
  //     centreCode: $event.centreCode
  //   })
  // }

  onCentreSelect($event: any) {

    if (!$event || $event.length === 0) {
      this.counsellingWorkForm.patchValue({
        centre: []
      });
      return;
    }

    const centreArray = $event.map((c: any) => ({
      centreName: c.centreName,
      centreCode: c.centreCode
    }));

    this.counsellingWorkForm.patchValue({
      centre: centreArray
    });
  }

  onCounselorSelected(selected: any) {
    console.log('Selected counselor:', selected);
    this.counsellingWorkForm.get('counsellorName')?.setValue(selected.name);
    // If using Reactive Forms, this value will also be automatically set
  }
  onTeacherSelect(selected: any) {
    console.log('onTeacherSelect:', selected);
    this.counsellingWorkForm.get('submittedBy')?.setValue(selected.userName);
    // If using Reactive Forms, this value will also be automatically set
  }

  // bulkChangeObservationData(){
  //   this.service.bulkChangeWorkUpdateData()
  // }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

}
